import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class CatchPartnerSpecials extends React.Component {
  render() {
    let marqueeSpeed = 20;
    let config = this.props.catchAnnouncementsConfig.filter((config)=> config.key == 'CATCH_PARTNER_SPECIALS_TEXT_ROTATE_SPEED');
    if(config.length > 0) {
      marqueeSpeed = config[0].value;
    }
    const catchPartnerSpecials = this.props.catchPartnerSpecials.sort((a, b) => parseInt(a.sort_order) - parseInt(b.sort_order));
    const catchPartnerSpecialsList = [];
    catchPartnerSpecials.forEach((news)=>{
      catchPartnerSpecialsList.push((<p>{news.partner_special}<br/><br/></p>));
    })
    if(!catchPartnerSpecialsList.length) {
      marqueeSpeed = 0;
    }
    return (
      <div className="row cath-news-section">
        <div className="col-md-12">
          <h4 className="catch-hotel-specials-label">
            Catch Hotel Specials:
          </h4>
          <div className="catch-partner-special-list">
           <div className="scrolling" style={{animation: `marquee ${marqueeSpeed}s linear infinite`}}>
            {catchPartnerSpecialsList.length ? catchPartnerSpecialsList : <p id='catchPartnerSpecialsInfo'>No hotel specials found...</p>}
           </div>
          </div>
        </div>
      </div>
    );
  }
}
CatchPartnerSpecials.propTypes = {
};
export default CatchPartnerSpecials;



// WEBPACK FOOTER //
// src/routes/home/components/CatchPartnerSpecials.js